import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { ReviewsBar } from './components/ReviewsBar';
import { Problems } from './components/Problems';
import { NetballReadyStats } from './components/NetballReadyStats';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { CountdownSection } from './components/CountdownSection';
import { Pricing } from './components/Pricing';
import { TacticalPlaybookPro } from './components/TacticalPlaybookPro';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-[#0a0a0a]" data-id="element-0" data-mp="23vupqgmff2wq">
      <noscript data-id="element-1" data-mp="23ut97wmn5o7m">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="23t8h0dnsuhcx" />
      </noscript>
      <Hero data-id="element-3" data-mp="3rcj6y3gog175" />
      <main data-id="element-4" data-mp="3rbrc4uuwm7hx">
        <ReviewsBar data-id="element-5" data-mp="3rdapodp6e4g0" />
        <Problems data-id="element-6" data-mp="3rcswjpxt86cb" />
        <NetballReadyStats data-id="element-7" data-mp="3reccfffk0fdk" />
        <Volumes data-id="element-8" data-mp="5orv1p50w72" />
        <Bonuses data-id="element-9" data-mp="6801qozk67w" />
        <CountdownSection data-id="element-10" data-mp="4n6o4eeqtbm" />
        <Pricing data-id="element-11" data-mp="82jt1oitsae" />
        <TacticalPlaybookPro data-id="element-12" data-mp="2zl3brl12165b" />
        <Testimonials data-id="element-13" data-mp="2zlv8iz6e19x6" />
        <Guarantee data-id="element-14" data-mp="2zmo3z3zwcd00" />
        <Faq data-id="element-15" data-mp="2zn6biws0edn8" />
        <FinalCta data-id="element-16" data-mp="33mouhn09senf" />
      </main>
      <Footer data-id="element-17" data-mp="33lwywc6oagx5" />
    </div>;
}